import React , { useState } from "react";
import { connect } from "react-redux";
import { Grid, IconButton } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Subtitulo from "../../../shared/components/Subtitulo";
import AutoComplete from "../../../shared/components/Autocomplete";
import { montarUrlHelpExames } from "../../../shared/utils/formatacoes";
import { EntradaTexto, Selecao } from "../../../shared/components/bibliotecaComponentes";
import { useMaterialConservante } from "../customHooks/useMaterialConservante";
import LightTooltip from "../../../shared/components/LightTooltip";
import { useExame } from "../customHooks/useExame";
import { useFocus } from "../customHooks/useFocus";
import { HelpCircle } from "react-feather";
import { STATUS_VOUCHER_GERADO_AUTOMATICAMENTE } from "../../../shared/utils/Constantes";
import _ from "lodash";
import ScrollToBottom from 'react-scroll-to-bottom';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import store from '../../../store';
import { mensagemAlertaActions } from '../../mensagemAlerta/redux';

export const DadosExame = props => {
  const {
    handleChangeConservante,
    handleChangeMaterial,
    ehVeterinario, 
    handleChange,
    possuiVoucher,
    conservante,
    exameValido,
    laboratorio,
    idContrato,
    dadosExame,
    material,
    recoleta,
    dadosVoucher,
    handleInserirExame, 
    restringirMaterial
  } = props;

  const classes = useStyles();

  const contratoLicitacao = idContrato && idContrato > 0;
  const [listExame, setListExame] = useState([]);

  const dadosMaterialConservante = useMaterialConservante(
    dadosExame.exame,
    material,
    handleChangeMaterial,
    conservante,
    handleChangeConservante
  );
  const dadosFocus = useFocus(
    dadosMaterialConservante.loadingConservante,
    dadosMaterialConservante.loadingMaterial,
    contratoLicitacao
  );
  const dadosCampoExame = useExame(
    dadosMaterialConservante.atualizarLoadings,
    dadosFocus.setFocus,
    ehVeterinario,
    handleChange,
    idContrato
  );

  function handleDeleteExameList(itemExame) {
    if (listExame.includes(itemExame)) {
      var novaLista = listExame.filter(e => e !== itemExame);

      setListExame(novaLista);

      if (handleInserirExame) {
        handleInserirExame(dadosExame, novaLista);
      }      
    }
  }

  const getOptionValueBuscaExames = option => {
    return {
      mnemonico: option.mnemonico,
      material: option.material
    };
  };

  const getOptionLabelBuscaExames = option => {
    return `${option.mnemonico}-${option.material} ${option.nome}`;
  };

  const loadOptions = async inputValue => {
    if (!inputValue) {
      return [];
    }
    const response = await dadosCampoExame.atualizarListaExames(inputValue, restringirMaterial);
    return await response;
  };

  const handleAddExame = () => {
    if (dadosExame?.exame?.material && dadosExame?.exame?.mnemonico) {

      var codigo = dadosExame.exame.material + '|' + dadosExame.exame.mnemonico;

      if (listExame?.length > 0) {
        if (listExame.find(v => v === codigo))
        {
          store.dispatch(mensagemAlertaActions.exibirNotificacao('Exame já inserido'));
          return;
        }
      }

      if (dadosExame.exame && material === 21) {
        if (!dadosExame?.especificacao || dadosExame?.especificacao?.length === 0) {
          store.dispatch(mensagemAlertaActions.exibirNotificacao('É necessário especificar a amostra'));
          return;
        }
      }

      if (restringirMaterial && restringirMaterial !== 'DIV') {
        if (dadosExame.exame.material !== 'DIV' && dadosExame.exame.material !== restringirMaterial) {
          store.dispatch(mensagemAlertaActions.exibirNotificacao('Material "' + dadosExame.exame.descricaoMaterial + '" não compatível com o material dos exames já inseridos'));
          return;
        }
      }

      
      var exames = [...listExame, codigo];
      
      setListExame(exames);
      if (handleInserirExame) {
        handleInserirExame(dadosExame, exames);
      }        

      dadosExame.exame = null;
    }
  }

  const obterIconeHelpExames = (option, focado) => {
    const url = montarUrlHelpExames(option.mnemonico, option.material, laboratorio);

    return (
      <a href={url} target="_blank" rel="noopener noreferrer" >
        <LightTooltip title="Help de Exame">
          <div style={{ float: "right", cursor: "pointer" }}>
            <HelpCircle
              size={19}
              color={focado ? "#E040FB" : "#61688B"}
              style={{
                float: "right",
                marginRight: "10px",
                marginTop: "6px",
                cursor: "pointer"
              }}
            />
          </div>
        </LightTooltip>
      </a>
    );
  };

  const divMaterial = (
    <Grid item xs={12} sm={6} md={3} lg={3} key={dadosExame?.exame?.mnemonico ?? ""}>
      <Selecao
        etiqueta="Material"
        id="material"
        campoRequerido={dadosMaterialConservante.listaMateriais.length > 0}
        desativarCampo={Boolean(
          (possuiVoucher && dadosVoucher.status !== STATUS_VOUCHER_GERADO_AUTOMATICAMENTE) ||
          dadosMaterialConservante.listaMateriais.length <= 1
        )}
        opcoes={
          dadosMaterialConservante.listaMateriais.length > 0
            ? dadosMaterialConservante.listaMateriais
            : [{ codigo: "NR", descricao: "Não requer" }]
        }
        codigo={dadosMaterialConservante.listaMateriais.length > 0 ? material : "NR"}
        handleChange={handleChangeMaterial}
        disabled={dadosExame?.exame?.mnemonico ? true: false}
      />
    </Grid>
  );

  const divConservante =
    (
      <Grid item xs={12} sm={6} md={3} lg={3}>
        <Selecao
          etiqueta="Conservante"
          id="conservante"
          campoRequerido={dadosMaterialConservante.listaConservantes.length > 0}
          desativarCampo={Boolean(dadosMaterialConservante.listaConservantes.length <= 1)}
          opcoes={
            dadosMaterialConservante.listaConservantes.length > 0
              ? dadosMaterialConservante.listaConservantes
              : [{ codigo: "NR", descricao: "Não requer" }]
          }
          codigo={dadosMaterialConservante.listaConservantes.length > 0 ? conservante : "NR"}
          handleChange={handleChangeConservante}
          disabled={(dadosExame.exame && material)===false}

        />
      </Grid>
    );

  const divAmostra =
  dadosExame.exame || listExame?.length ?(
      <Grid item xs={11}>
        <EntradaTexto
          onChange={event => handleChange("especificacao", event.target.value)}
          value={dadosExame.especificacao}
          etiqueta="Especifique a amostra"
          maximoCaracteres={120}
          id="especificacao"
          campoRequerido={dadosExame.exame && material === 21}
        />
      </Grid>
    ):(<Grid item xs={11}></Grid>);

    return (
    <Grid item >
        <Grid item container spacing={2} xs={12}>
          <Grid item xs={12}>
            <Grid container spacing={2}>
              <Grid item xs={8}>
                <Grid container spacing={2}>
                  <Subtitulo subtitulo="Exames" />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} >
              <AutoComplete
                id="exame"
                placeholder={"Buscar por código ou nome"}
                defaultOptions
                limpavel
                loadOptions={loadOptions}
                getOptionValue={getOptionValueBuscaExames}
                getOptionLabel={getOptionLabelBuscaExames}
                onChange={dadosCampoExame.handleChangeAutocompleteExame}
                value={dadosExame.exame}
                exibirIconeLink
                addonOption={obterIconeHelpExames}
                campoInvalido={!exameValido}
                obrigatorio
                disabled={Boolean(
                  (possuiVoucher && dadosVoucher.status !== STATUS_VOUCHER_GERADO_AUTOMATICAMENTE) ||
                  recoleta
                )}
              />
          </Grid>
          {divMaterial}
          {divConservante}
          <Grid container item xs={6}>
            {divAmostra}
            <Grid item xs={1} >
              <IconButton style={{marginLeft: '4px', width: '50px', height: '50px'}} color="secondary" className={classes.iconButton} onClick={() => handleAddExame()} aria-label='Search'>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fillRule="evenodd" clipRule="evenodd" d="M1 12C1 18.0751 5.92487 23 12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12ZM21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12ZM11 16C11 16.5523 11.4477 17 12 17C12.5523 17 13 16.5523 13 16V13H16C16.5523 13 17 12.5523 17 12C17 11.4477 16.5523 11 16 11H13V8C13 7.44772 12.5523 7 12 7C11.4477 7 11 7.44772 11 8V11H8C7.44772 11 7 11.4477 7 12C7 12.5523 7.44772 13 8 13H11V16Z" fill="#BF43AB"/>
                </svg>
              </IconButton>
            </Grid>
          </Grid>       
          <Grid item xs={12}>
          <fieldset className={classes.campoEmail} >
            <legend >
              Exames Adicionados
            </legend>
            <ScrollToBottom
              className={classes.schroll}
            >
              <div className={classes.containerExame}>
                {
                  listExame.map((itemExame, i) => {
                    return (
                      <div className={classes.divSpan} key={itemExame}>
                        <div className={classes.itemListExame}>
                          <span>
                            {itemExame}
                          </span>
                          <span >
                            <IconButton size="small"
                              onClick={(e) => handleDeleteExameList(itemExame)}>
                              <HighlightOffIcon className={classes.excluir} />
                            </IconButton>
                          </span>
                        </div>
                      </div>
                    );
                  })
                }
              </div>
            </ScrollToBottom>
          </fieldset>
        </Grid>    
        </Grid>       
    </Grid>
  );
};

const useStyles = makeStyles({
  divOption: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between"
  },
  blueBorder: {
    border: "solid blud 1px"
  },
  schroll: {
    height: "45px",
    width: "100%"    
  },
  exame: {
    border: "none",
    background: "transparent",
    marginLeft: "5px",
    outline: "1",
  },
  campoExame: {
    border: "solid 1px #61688B",
    borderRadius: "4px",
    width: "100%",
    color: "#61688B",
    fontSize: "14px",
    minHeight: "86px"
  },
  containerExame: {
    display: "flex",
    flexFlow: "row wrap"
  },
  divSpan: {
    paddingLeft: "10px",
    paddingBottom: "10px"
  },
  itemListExame: {
    borderRadius: "20px",
    background: "rgba(192, 192, 222, 0.4)",
    paddingLeft: "10px",
    paddingRight: "10px",
    marginTop: "5px",
    alignItems: "center ",
    flex: "none",
    fontSize: "14px",
  },
  containerFooterExame: {
    fontStyle: "normal",
    fontWeight: "normal",
    fontSize: "12px",
    lineHeight: "10px",
    marginTop: "5px",
    color: "#23144D",
    textAlign: "right"
  },  
});

const mapStateToProps = state => {
  return {
    ehVeterinario: false,
    laboratorio: state.login.laboratorio
  };
};

export default connect(mapStateToProps)(DadosExame);
